import Router from "./components/layout/Router";
import { BillProvider } from "./context/BillContext";
import { Helmet } from "react-helmet";

const App = () => {
  return (
    <>
      <Helmet>
        <title>Ask The Bill</title>
        <meta
          name="description"
          content="Ask the Bill is a platform to simplify and explain legislative bills like the Tax Reform Bill 2024 for Nigerians. Ask questions and get answers instantly."
        />
        <meta property="og:title" content="Ask The Bill" />
        <meta
          property="og:description"
          content="Ask the Bill is a platform to simplify and explain legislative bills like the Tax Reform Bill 2024 for Nigerians. Ask questions and get answers instantly."
        />
        <meta
          property="og:image"
          content="%PUBLIC_URL%/bg-1.jpeg
        "
        />
      </Helmet>
      <BillProvider>
        <Router />
      </BillProvider>
    </>
  );
};

export default App;
